import React, { Component } from 'react';
import ReactSlick from 'react-slick';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import preventTouchScroll from './preventTouchScroll';
import Pagination from './pagination/pagination';
import ProductLabels from '../../../reusable-components/Labels/ProductLabels';
// import Labels from "../Labels/labels";
import * as overlayActions from '../overlayFull/overlayActions';
import * as galleryActions from './galleryActions';
import { addClass } from '../../utils/ie9polyfills';

import arrayToString from '../../../utils/js/arrayToString';

import './slick.less';

class SlickComponentMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.slider = React.createRef();
  }

  componentDidMount() {
    if (this.slider && this.slider.current.innerSlider) {
      this.slider.current.innerSlider.list.setAttribute('tabindex', 0);
      this.slider.current.innerSlider.list.focus();
    }
    this.props.REGISTER_SLIDER('mobileSlider', this.slider.current);
  }

  handleFirstPicLoaded() {
    const footer = document.getElementById('pdp-footer');
    addClass(footer, 'showFooter');
  }

  render() {
    const BFCondition = window.config.black_friday_ff;
    /**
     * The Discount Percentage, which determines if the Discount Label is shown. (10% or more)
     * @type {string}
     */
    const discountPercentage =
      this.props?.app?.data?.prices?.discount_percentage || '0';
    const { images, title, labels } = this.props.app.data;
    const { selections } = this.props.app;
    const selectedLabels = selections.sizeDetails
      ? selections.sizeDetails.labels
      : labels;
    const { activeImage, rerenderGallery } = this.props;

    return rerenderGallery ? (
      <div className="slickComponent mobile">
        <div className="mainSliderHolder" data-testid="product-slider">
          {selectedLabels.length > 0 && (
            <ProductLabels
              labels={selectedLabels}
              discountPercentage={parseInt(discountPercentage, 10)}
              isProductPage
              extraClasses={arrayToString(BFCondition)}
            />
          )}
          <ReactSlick
            className="mainSlider"
            ref={this.slider}
            dots={false}
            afterChange={current => this.props.IMAGE_CONTROLLER(current)}
            infinite={false}
            arrows={false}
            speed={200}
            slidesToShow={1}
            slidesToScroll={1}
            initialSlide={activeImage}
            touchThreshold={10}
            lazyLoad
          >
            {images.gallery.map((item, i) => {
              if (item.thumb !== '') {
                return (
                  <div className="galleryImage" key={item.image}>
                    <img
                      data-name="mobileGalleryImg"
                      src={item.image}
                      alt={title}
                      onLoad={() =>
                        i === 0 ? this.handleFirstPicLoaded() : null
                      }
                    />
                  </div>
                );
              }
              return null;
            })}
          </ReactSlick>
          <Pagination />
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = ({ app, gallery }) => {
  return {
    app,
    gallery,
    rerenderGallery: gallery.rerenderGallery,
    activeImage: gallery.activeImage
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...galleryActions, ...overlayActions }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(preventTouchScroll(SlickComponentMobile));
